<template>
    <div>
        <config-item-values
                v-if="!editMode && item"
                :item="item"
                @value-created="valueCreated"
        >

        </config-item-values>
        <config-item-add-edit :item="item" v-if="editMode"></config-item-add-edit>
    </div>
</template>

<script>
    import ConfigItemValues from './ConfigItemValues'
    import ConfigItemAddEdit from './ConfigItemAddEdit'

    export default {
        name: "config-item",

        components: {
            ConfigItemValues,
            ConfigItemAddEdit
        },

        props: {
            item: {
                required: true,
            },
            editMode: {
                type: Boolean,
                default: false
            }
        },

        methods: {
            valueCreated(value) {
                this.item.values.push(value)
            }
        }
    }
</script>

<style scoped>

</style>